import React from 'react';

const ActivitiesSnow = () => {
  return (
    <section id="activities-snow">

      <h1>Hó- és síkosságmentesítés</h1>

      <header>

        <div id="activities-snow-info">

          <h2>Üzletágvezető:</h2>
          <ul>
            <li>Ponyokai Bálint</li>
          </ul>

          <h2>Elérhetőség:</h2>
          <ul>
            <li><a href="tel: +36 70/610-1644">70/610-1644</a></li>
          </ul>

        </div>

        <div id="activities-snow-img"></div>

      </header>

      <div id="activities-snow-text">

        <div>
          <p>
            Kft-nk 2012. december 1-jétől látja el az önkormányzattal kötött szerződés alapján. 
            <br/>
            Feladatunk a város belterületi útjainak, illetve gyalogos útjain a balesetmentes közlekedés feltételének biztosítása. 	  
          </p>

          <p>
            Tevékenységünkhöz a Kft. rendelkezésére áll 1 db AGT és 1 db IFA tolólapos sószórós gép, valamint 1 db új beszerzésű tolólapos, sószóróval felszerelt Traktor. Ezekkel a gépekkel tudjuk elvégezni a járdákon, a város útjain, illetve a kerékpárúton a hóeltakarítást és a síkosság-mentesítést. 
            <br/>
            A közutak takarításánál alvállalkozókat is bevonunk, a hóhelyzetnek megfelelően.
          </p>

        </div>

        <div>
          <p>
            A gyalogos utak tisztításához fontos a nagy létszámú közmunkás, ezzel is csökkentve a saját és ezáltal a város költségeit.
          </p>

          <p>
            Takarékosságra törekszünk, a balesetmentes közlekedés feltételeinek biztosítása mellett.
          </p>

          <p>
            E tevékenység tapasztalatai alapján megállapítható, hogy a tevékenység elrendelésénél, illetve ellenőrzésénél kiemelt fontosságú a kapcsolattartás módja, rendszere. 
          </p>

        </div>

      </div>

    </section>
  );
};

export default ActivitiesSnow;